import React from 'react';
import {
	ReactHookFormCheckbox,
	type ReactHookFormCheckboxProps,
} from '@netx/core-components/Form/Checkbox';
import type {ICustomFormItem, CustomFormFormValues} from '../../types';
import {
	getCustomFormItemTranslatedLabel,
	getCustomFormSubFieldName,
} from '../../utils';

export interface ReactHookFormCustomFormItemCheckboxesProps<
	TValues extends CustomFormFormValues = CustomFormFormValues,
> extends Omit<
		ReactHookFormCheckboxProps<TValues>,
		'label' | 'name' | 'required'
	> {
	item: ICustomFormItem;
}

export const ReactHookFormCustomFormItemCheckboxesPrimitive = <
	TValues extends CustomFormFormValues = CustomFormFormValues,
>({
	item,
	control,
}: ReactHookFormCustomFormItemCheckboxesProps<TValues>) => {
	const {disabled, value, required} = item;

	if (typeof value === 'string') return null;

	return (
		<>
			{value.map((val) => {
				const name = getCustomFormSubFieldName(item, val);
				return (
					<ReactHookFormCheckbox
						key={name}
						control={control}
						disabled={
							disabled || typeof val === 'string' ? false : val.disabled
						}
						label={
							<span
								dangerouslySetInnerHTML={{
									__html:
										typeof val === 'string'
											? val
											: getCustomFormItemTranslatedLabel(val),
								}}
							/>
						}
						name={name}
						required={required}
					/>
				);
			})}
		</>
	);
};

export const ReactHookFormCustomFormItemCheckboxes =
	ReactHookFormCustomFormItemCheckboxesPrimitive;

export default ReactHookFormCustomFormItemCheckboxes;
